import React, { ReactElement, useEffect } from 'react';
import 'react-dates/initialize';

import { useAppDispatch } from './base/hooks';
import { appActions } from './base/redux/slices/appSlice';
import { AppType } from './base/enums';
import { EmployerApp } from './employer/EmployerApp';
import { WorkerApp } from './worker/WorkerApp';
import { RecruiterApp } from './recruiter/RecruiterApp';

export const App = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!window.GLOBALS) {
            throw new Error('App cannot be initialized. GLOBALS config not found!');
        }

        if (!window.GLOBALS.appType) {
            throw new Error('Value "appType" is not present in GLOBALS config!');
        }

        dispatch(appActions.setAppType(window.GLOBALS.appType));

        if (window.GLOBALS.referrer) {
            dispatch(appActions.setReferrer(window.GLOBALS.referrer));
        }
        if (window.GLOBALS.language) {
            dispatch(appActions.setLanguage(window.GLOBALS.language));
        }
    }, []);

    const renderApp = (): ReactElement => {
        switch (window.GLOBALS.appType) {
            case AppType.Worker:
                return <WorkerApp />;
            case AppType.Recruiter:
                return <RecruiterApp />;
            case AppType.Empoloyer:
                return <EmployerApp />;
            default:
                // eslint-disable-next-line max-len
                throw new Error('Invalid value of appType was provided in GLOBALS config!');
        }
    };

    return <div className='razem-app'>{renderApp()}</div>;
};
